import { useState } from 'react';
import AM_antenna from './AM_antenna';
import RF_antennas from './RF_antennas';
import Xperience_antenna from './Xperience_antenna';
import Concealed from './Concealed';

export default function TabNavigation() {
  const [activeTab, setActiveTab] = useState('tab1');

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  // Content components for each tab
  const renderTabContent = () => {
    switch (activeTab) {
      case 'tab1':
        return <div className="tab-content-container10"><AM_antenna/></div>;
      case 'tab2':
        return <div className="tab-content-container10"><RF_antennas/> </div>;
      case 'tab3':
        return <div className="tab-content-container10"><Concealed/> </div>;
      default:
        return null;
    }
  };

  return (
    <div className="tab-system-container10 mx-5">
      {/* Navigation Bar */}
      <div className="tab-navigation10">
        <div className="row g-0">
          <div className="col-sm-4">
            <button
              className={`tab-button10 ${activeTab === 'tab1' ? 'active' : ''}`}
              onClick={() => handleTabClick('tab1')}
            >
              {/* <span className="tab-icon">
                <i className="fas fa-shopping-cart"></i>
              </span> */}
              <span className="tab-text10 ">AM Systems</span>
            </button>
          </div>
          
          <div className="col-sm-4">
            <button
              className={`tab-button10 ${activeTab === 'tab2' ? 'active' : ''}`}
              onClick={() => handleTabClick('tab2')}
            >
              {/* <span className="tab-icon">
                <i className="fas fa-chart-line"></i>
              </span> */}
              <span className="tab-text10 ">RF Systems</span>
            </button>
          </div>
          
          <div className="col-sm-4">
            <button
              className={`tab-button10 ${activeTab === 'tab3' ? 'active' : ''}`}
              onClick={() => handleTabClick('tab3')}
            >
              {/* <span className="tab-icon">
                <i className="fas fa-cog"></i>
              </span> */}
              <span className="tab-text10 ">Concealed System</span>
            </button>
          </div>

          {/* <div className="col-sm-3">
            <button
              className={`tab-button10 ${activeTab === 'tab4' ? 'active' : ''}`}
              onClick={() => handleTabClick('tab4')}
            >

              <span className="tab-text ">Concealed System</span>
            </button>
          </div> */}
        </div>
      </div>

      {/* Content Area */}
      <div className="tab-content-wrapper">
        {renderTabContent()}
      </div>

      {/* CSS - using style tag for demo, but you could put this in a separate CSS file */}
      <style jsx>{`
        .tab-system-container10 {
          font-family: 'Montserrat', sans-serif;
          margin: 1.5rem 0;
        }
        
        .tab-navigation10 {
          background-color: #f8f9fa;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }
        
        .tab-button10 {
          width: 100%;
          background-color: #f8f9fa;
          border: none;
          color: #495057;
          transition: all 0.3s ease;
          text-align: center;
          font-weight: 500;
          font-size: 1rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content-item: center;
          height: 100%;
          cursor: pointer;
        }
        
        .tab-button10:hover {
          background-color: #e9ecef;
        }
        
        .tab-button10.active {
          background-color: #2d3e50;
          color: white;
        }
        
        .tab-icon10 {
          display: block;
          font-size: 1.5rem;
          margin-bottom: 0.5rem;
        }
        
        .tab-content-container10 {
          background-color: white;
          padding: 2rem;
          border-radius: 0 0 8px 8px;
          min-height: 200px;
          margin-top: 1px;
        }
        
        /* Responsive adjustments */
        @media (max-width: 768px) {
          .tab-text10 {
            font-size: 0.85rem;
          }
        }
      `}</style>
    </div>
  );
}